import { apiClient as api } from "./httpClient";

/**
 * Evoluções pendentes por profissional (RN-214): a sessão aconteceu e o registro clínico não foi
 * feito. Conta só sessão com presença "Compareceu" — falta e cancelamento não geram evolução.
 */
export interface PendingEvolutionItem {
  scheduleId: string;
  /** Data/hora no relógio da entidade; a API já converteu. */
  sessionAt: string;
  patientId: string;
  patientName: string;
  serviceTypeName: string | null;
  presenceName: string | null;
  daysWaiting: number;
}

export interface PendingEvolutionsRow {
  professionalId: string;
  professionalName: string;
  professionalTypeName: string | null;
  pending: number;
  /** Evoluções já feitas do profissional no período. */
  done: number;
  /** Sessões realizadas (feitas + pendentes). */
  sessions: number;
  /** Feitas sobre realizadas, em %. */
  completionRate: number;
  oldestDays: number;
  /** A fila vem junto: abrir a lista não vai ao servidor de novo. */
  items: PendingEvolutionItem[];
}

export interface PendingAgeSlice {
  label: string;
  count: number;
}

export interface PendingEvolutionsReport {
  items: PendingEvolutionsRow[];
  from: string;
  to: string;
  sessions: number;
  done: number;
  pending: number;
  completionRate: number;
  professionalsWithPending: number;
  byAge: PendingAgeSlice[];
}

export interface PendingEvolutionsFilters {
  /** AAAA-MM. Quando vem, manda: define o mês inteiro e ignora as datas soltas. */
  competence?: string;
  from?: string;
  to?: string;
  professionalId?: string;
}

const params = (filters: PendingEvolutionsFilters) => ({
  ...(filters.competence ? { competence: filters.competence } : {}),
  ...(filters.from ? { from: filters.from } : {}),
  ...(filters.to ? { to: filters.to } : {}),
  ...(filters.professionalId ? { professionalId: filters.professionalId } : {}),
});

export const pendingEvolutionsService = {
  get: async (filters: PendingEvolutionsFilters): Promise<PendingEvolutionsReport> => {
    const response = await api.get("/reports/pending-evolutions", { params: params(filters) });
    return response.data;
  },
  /** Planilha com a linha de cada profissional e a fila inteira (RN-214g). */
  exportXlsx: async (filters: PendingEvolutionsFilters): Promise<Blob> => {
    const response = await api.get("/reports/pending-evolutions/export", {
      params: params(filters),
      responseType: "blob",
      timeout: 60000,
    });
    return response.data;
  },
};
